import {
  SET_PRATT_TABLE,
  SET_SHILTS_TABLE
} from "./mutations";

const initialState = {
  prattTable: null,
  schiltzTable: null
};

const tablesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PRATT_TABLE:
      return { ...state, prattTable: payload }

    case SET_SHILTS_TABLE:
      return { ...state, schiltzTable: payload }

    default:
      return state;
  }
};

export default tablesReducer;
